import styled from "styled-components";
import {
  SideSheetMainWrapper,
  IconChevronRight,
  SideSheetOverlay,
  Heading,
  HEADING_LEVELS,
  HEADING_TYPES,
} from "@cdkglobal/radial";
import type { HeadingProps } from "@cdkglobal/radial";
import type React from "react";

export const StyledSideSheetMainWrapper = styled(SideSheetMainWrapper)``;

export const StyledSideSheetOverlay = styled(SideSheetOverlay)`
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 999;
  pointer-events: ${({ isCollapsed }) => (isCollapsed ? "none" : "auto")};
`;

export const StyledSideSheetHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75rem 1rem;
  background: var(--color-surface-default, #fff);
  border-bottom: 1px solid var(--color-border-subtle, #e0e0e0);
  gap: 0.5rem;
`;

export const StyledSideSheetTopBar = styled.div`
  flex-shrink: 0;
  height: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  padding-bottom: 0rem;
  margin-bottom: 0rem;
  background: var(--color-surface-default, #fff);
`;

export const StyledSideSheetTitle = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_1,
  type: HEADING_TYPES.HEADING_1,
})`
  margin: 0;
  margin-left: 0.25rem;
`;

export const StyledSideSheetFooter = styled.div`
  flex-shrink: 0;
  height: 3.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: var(--color-surface-default, #fff);
  border-top: 1px solid var(--color-border-subtle, #e0e0e0);
`;

export const StyledSideSheetBody = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0; /* required for flex children to scroll correctly */
`;

export const EmptyStateContainer = styled.div`
  align-items: center;
  text-align: center;
`;

export const EmptyStateText = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_3,
  type: HEADING_TYPES.SUBTITLE_2,
})``;

export const StyledStickyHeaderContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 50;
  background: var(--color-surface-default, #fff);
`;

export const StyledPageWrapper = styled.div`
  width: 100%;
`;

export const StyledPageLabel = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_2,
  type: HEADING_TYPES.HEADING_2,
})`
  display: flex;
  margin-left: 1rem;
  margin-bottom: auto;
  color: #196fe1;
  align-items: center;
`;

export const StyledIconChevronRight = styled(IconChevronRight)`
  fill: #196fe1;
`;

export const SelectorWrapper = styled.div`
  width: 100%;
  display: block;
`;

export const SetupSelectorContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
  & > *:last-child {
    width: 150px;
  }
`;

export const LoaderContainer = styled.div`
  position: absolute;
  z-index: 21;
  background: #fff;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoaderImg = styled.img`
  height: 60px;
  width: 60px;
`;
